<template>
  <v-card>
    <v-card-title style="height: 48px; flex-wrap: nowrap;">
      <v-layout class="unitImagesHeader" row>
        <v-flex>
          <span class="unitImagesName">IMAGES OF CLIENTS IN UNIT {{ unit.name }}</span>
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
      <v-btn xs icon flat @click.stop="close()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text style="height: calc(90vh - 96px); overflow-y: auto;">
      <v-layout v-if="unit" row wrap>
        <div v-for="(unitClientSummary, index) of unitClientSummaries" :key="index" pa-1 class="unitClientInfoContainer">
          <v-layout row>
            <client-image :clientID="unitClientSummary.clientSummary.clientID.id" :clientName="unitClientSummary.clientSummary.clientName" class="unitClientImage" />
            <span class="unitClientInfo">
              <div class="unitClientName">{{ `${unitClientSummary.clientSummary.clientName.first} ${unitClientSummary.clientSummary.clientName.last}` }}</div>
              <div class="unitClientRoomName">Room {{ unitClientSummary.roomName }}</div>
            </span>
          </v-layout>
        </div>
      </v-layout>
    </v-card-text>

    <v-card-actions />
  </v-card>
</template>


<script lang="js">
import ClientImage from './ClientImage.vue';

export default {
  name: 'UnitClientsCard',
  data() {
    return {
    };
  },
  props: {
    onClose: Function,
    unit: Object
  },
  components: {
    'client-image': ClientImage
  },
  computed: {
    unitClientSummaries() {
      return this.$store.getters.getUnitClientSummaries(this.unit.bedBoardUnitID.id);
    }
  },
  methods: {
    close() {
      this.onClose();
    },
  }
};
</script>


<style lang="scss">
.unitClientImage {
  height: 90px;
  margin-right: 15px;
  width: 60px;
}
.unitClientInfo {
  height: 100%;
}
.unitClientInfoContainer {
  margin: 10px;
  width: 260px;
}
.unitClientName {
  font-weight: 700;
}
.unitClientRoomName {
  font-style: italic;
}
.unitImagesName {
  color: #39b54a;
  font-size: 14px;
  font-weight: 700;
}
</style>
